import { z } from "zod";

export const NotificationHelpItemSchema = z.object({
  Description: z.string(),
  Order: z.number().optional(),
  Title: z.string(),
  Url: z.string().optional(),
});

export type NotificationHelpItemType = z.infer<
  typeof NotificationHelpItemSchema
>;
